import { render, staticRenderFns } from "./upkeeptask.vue?vue&type=template&id=1cfde8c6&"
import script from "./upkeeptask.vue?vue&type=script&lang=js&"
export * from "./upkeeptask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports